import { render, staticRenderFns } from "./InjuryFormDialog.vue?vue&type=template&id=f1839398&scoped=true"
import script from "./InjuryFormDialog.vue?vue&type=script&lang=js"
export * from "./InjuryFormDialog.vue?vue&type=script&lang=js"
import style0 from "./InjuryFormDialog.vue?vue&type=style&index=0&id=f1839398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1839398",
  null
  
)

export default component.exports